/** @file One render in the AI view: thumbnail (opens full size), actor badge, caption, rev and size. */
import type { RenderEntry } from '@pose2d/api/render/renderEntry';
import { useState } from 'react';
import { useT } from '../../shell/i18n/useT';
import { actorTone } from '../activity/actorTone';
import { renderCaption } from './renderCaption';

/** An image that fails to load (the 24 h capability URL expired) says so instead. */
export function RenderCard({ entry, onOpen }: { entry: RenderEntry; onOpen: () => void }) {
  const t = useT();
  const [broken, setBroken] = useState(false);
  const caption = renderCaption(t, entry);
  return (
    <li className="ai-card">
      {broken ? <p className="ai-card-expired">{t('aiView.expired')}</p> : (
        <button type="button" className="ai-card-thumb" title={t('aiView.open')} onClick={onOpen}>
          <img src={entry.url} alt={caption} onError={() => { setBroken(true); }} />
        </button>
      )}
      <p className="ai-card-caption">
        <span className="live-pill" data-tone={actorTone(entry.actor)}>{entry.actor}</span> {caption}
      </p>
      <p className="ai-card-meta">{t('aiView.meta', { rev: entry.rev, w: entry.width, h: entry.height })}</p>
    </li>
  );
}
